export enum StandingColumns {
  RowNumber = "#",
  Teamname = "teamname",
  Byes = "byes",
  Draws = "draws",
  DrawsAway = "drawsAway",
  DrawsHome = "drawsHome",
  ForfeitsGiven = "forfeitsGiven",
  ForfeitsWonBy = "forfeitsWonBy",
  HighestScoreAgainst = "highestScoreAgainst",
  HighestScoreAgainstAway = "highestScoreAgainstAway",
  HighestScoreAgainstHome = "highestScoreAgainstHome",
  HighestScoreFor = "highestScoreFor",
  HighestScoreForAway = "highestScoreForAway",
  HighestScoreForHome = "highestScoreForHome",
  Losses = "losses",
  LossesAway = "lossesAway",
  LossesHome = "lossesHome",
  LowestScoreAgainst = "lowestScoreAgainst",
  LowestScoreAgainstAway = "lowestScoreAgainstAway",
  LowestScoreAgainstHome = "lowestScoreAgainstHome",
  LowestScoreFor = "lowestScoreFor",
  LowestScoreForAway = "lowestScoreForAway",
  LowestScoreForHome = "lowestScoreForHome",
  Percentage = "percentage",
  PercentageAway = "percentageAway",
  PercentageHome = "percentageHome",
  Played = "played",
  PlayedAway = "playedAway",
  PlayedHome = "playedHome",
  PointDifference = "pointDifference",
  PointDifferenceAway = "pointDifferenceAway",
  PointDifferenceHome = "pointDifferenceHome",
  ResultString = "resultString",
  ResultStringAway = "resultStringAway",
  ResultStringHome = "resultStringHome",
  ScoredAgainst = "scoredAgainst",
  ScoredAgainstAway = "scoredAgainstAway",
  ScoredAgainstHome = "scoredAgainstHome",
  ScoredFor = "scoredFor",
  ScoredForAway = "scoredForAway",
  ScoredForHome = "scoredForHome",
  Streak = "streak",
  StreakAway = "streakAway",
  StreakHome = "streakHome",
  Washouts = "washouts",
  WinPercentage = "winPercentage",
  WinPercentageAway = "winPercentageAway",
  WinPercentageHome = "winPercentageHome",
  Wins = "wins",
  WinsAway = "winsAway",
  WinsHome = "winsHome",
  BonusStandingPoints = "bonusStandingPoints",
  ByeStandingPoints = "byeStandingPoints",
  GamesBehind = "gamesBehind",
  PenaltyStandingPoints = "penaltyStandingPoints",
  StandingPoints = "standingPoints",
  StandingPointsGiven = "standingPointsGiven",
  StandingPointsAway = "standingPointsAway",
  StandingPointsHome = "standingPointsHome",
  TeamDifferential = "teamDifferential",
  TeamDifferentialAway = "teamDifferentialAway",
  TeamDifferentialHome = "teamDifferentialHome",
  Div = "DIV",
  Conf = "CONF",
  Home = "HOME",
  Away = "AWAY",
  Actions = "actions", // not a part of api response
}
